import React from 'react';
import { connect } from 'react-redux';
import DynamicFormControls from "../DynamicForm/DynamicFormControls";
import ControlService from "../../helper/controlservice";
import { resetFormData } from "../actions";
import { actionType, ruleCheck } from "../../helper/common/rules";

const _ = require("lodash");

const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
function bindAction(dispatch) {
    return {
        resetData: (data, storekey) => dispatch(resetFormData(data, storekey)),
    };
}
class RulesContainer extends React.PureComponent {
    constructor() {
        super();

        this.state = {
            data: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var data = nextProps.data[nextProps.formid + 'write'] ? nextProps.data[nextProps.formid + 'write'] : {}
        if (JSON.stringify(data) != JSON.stringify(prevState.data)) {
            return {
                data: data,
            };
        } else return null; // Triggers no change in the state
    }
    componentDidUpdate(prevProps, prevState) {
        const { control, action, formid } = this.props;
        const { data } = this.state;
        if (control.resetdatamodel && control.controlkey) {
            let Value = data ? data[control.controlkey] : '';
            let prevValue = prevState.data ? prevState.data[control.controlkey] : '';
            if (Value != prevValue) {
                debugger;
                if ((actionType(control.rules) == 'hide' || actionType(control.rules) == 'show')
                    && control.controlvalue
                    && control.controlvalue.find(x => !ControlService().isEmptyorNull(data[control.controlkey]) && x.toString().toLowerCase() == data[control.controlkey].toString().toLowerCase())
                ) {
                    var datamodel = ControlService().deepcopy(this.props.data[formid + action] ? this.props.data[formid + action] : {});

                    ControlService().GenerateDataJson(control.children, datamodel, null, true);
                    this.props.resetData(datamodel, formid + action);
                    if (!ruleCheck(control.rules, data)) {
                        var formvalidation = this.props.data[formid + action + "_validation"];

                        var _datamodel = this.props.data[formid + action] ? this.props.data[formid + action] : {};
                        for (let key in datamodel) {
                            var _control = ControlService().find(control.children, key, 'key');

                            if (_control) {
                                delete _datamodel[key];
                                if (formvalidation[key]) {
                                    delete formvalidation[key];
                                }
                            }
                        }
                        this.props.resetData(formvalidation, formid + action + "_validation");
                        this.props.resetData(_datamodel, formid + action);
                    }
                }
            }
        }
    }
    controls(control, formid, action, Disabled) {
        return control.children.map(ch => {
            return (
                <DynamicFormControls isDisabled={Disabled} key={ch.id} formid={formid} control={ch} action={action} />
            )
        })
    }
    renderControls(control, action, data, formid) {
        var controls = null

        if (actionType(control.rules) == '') {
            controls = this.controls(control, formid, action);
        }
        else if ((actionType(control.rules) == 'hide' || actionType(control.rules) == 'show') && ruleCheck(control.rules, data)) {
            controls = this.controls(control, formid, action);
        }
        else if (actionType(control.rules) == 'enable' || actionType(control.rules) == 'disable') {
            var Disabled = ruleCheck(control.rules, data) ? false : true
            controls = this.controls(control, formid, action, Disabled);
        }

        return controls;
    }
    render() {
        const { control, action, formid } = this.props;
        var { data } = this.state;
        return (
            data ?
                // <div className="row">
                this.renderControls(control, action, data, formid)
                // </div>
                : null
        );
    }
}

export default connect(
    mapStateToProps, bindAction
)(RulesContainer);